import { render, staticRenderFns } from "./BSManageUrenbonnenModal.vue?vue&type=template&id=3537d497"
import script from "./BSManageUrenbonnenModal.vue?vue&type=script&lang=js"
export * from "./BSManageUrenbonnenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports